import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import {store} from "./store/store";

import './App.css'

if (process.env.REACT_APP_DEBUG === 'true') {
  debugger;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
);
